import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export interface WalletTotalCardSkeletonProps {
    title: string;
    label: string;
    variant?: "default" | "compact";
}

export default function WalletTotalCardSkeleton({ title, label, variant = "default" }: WalletTotalCardSkeletonProps) {
    const isCompact = variant === "compact";

    return (
        <Paper
            elevation={0}
            role="status"
            aria-live="polite"
            aria-busy="true"
            sx={{
                width: "100%",
                overflow: "hidden",
                p: isCompact ? 1.75 : { xs: 2.25, sm: 2.75 },
                borderRadius: isCompact ? 3 : 4,
                bgcolor: "background.paper",
                border: (theme) => `1px solid ${alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.22 : 0.16)}`,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant={isCompact ? "subtitle2" : "body1"} color="text.secondary" sx={{ fontWeight: 800 }}>
                        {title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.25, fontWeight: 700 }}>
                        {label}
                    </Typography>
                </Box>
                <Skeleton variant="rounded" width={isCompact ? 32 : 48} height={isCompact ? 32 : 48} sx={{ borderRadius: isCompact ? 2 : 3 }} />
            </Box>
            <Skeleton width="82%" height={isCompact ? 36 : 54} sx={{ mt: 1 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: isCompact ? 1 : 1.5, mt: isCompact ? 1.5 : 2, pt: isCompact ? 1.25 : 2, borderTop: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}` }}>
                <Box>
                    <Skeleton width={42} height={18} />
                    <Skeleton width="92%" height={24} sx={{ mt: 0.4 }} />
                </Box>
                <Box>
                    <Skeleton width={42} height={18} />
                    <Skeleton width="92%" height={24} sx={{ mt: 0.4 }} />
                </Box>
            </Box>
        </Paper>
    );
}
